module.exports = __webpack_public_path__ + "media/images/logo-julaima-fcaaf1dc48904cad63513657f5476123.jpg";